module.exports = __webpack_public_path__ + "img/e-gov.f44b2703.svg";